import { useStaticQuery, graphql } from 'gatsby'

export const useBlogTags = () => {
  const { allBlogTag } = useStaticQuery(tagsQuery)
  return allBlogTag.nodes || []
}

const tagsQuery = graphql`
  query allBlogTagQuery {
    allBlogTag {
      nodes {
        ...BlogTag
      }
    }
  }
`
